<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    :style="{ height: tableWraperHeight }"
    :class="['l-x-table', isPage ? 'l-x-table--haspagination' : '']"
  >
    <div class="l-rblock">
      <vxe-table
        :expand-row-keys="expandRowKeys"
        :default-sort="defaultSort"
        @checkbox-all="handleSelectAll"
        @checkbox-change="handleSelectionChange"
        @cell-click="handleCellClick"
        @cell-mouseenter="cellMouseEnter"
        @cell-mouseleave="cellMouseLeave"
        @cell-dblclick="handleCellDblclick"
        @cell-menu="handleCellMenu"
        @header-cell-click="headerClick"
        @header-cell-menu="headerContextmenu"
        @filter-change="filterChange"
        @current-change="currentChange"
        @resizable-change="headerDagend"
        @toggle-row-expand="expandChange"
        ref="learunTable"
        v-if="isShowTable"
        style="width: 100%"
        size="mini"
        :border="border"
        :height="tableHeight"
        :max-height="maxHeight"
        :min-height="minHeight"
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :header-row-class-name="headerRowClassName || 'l-x-table-header-row'"
        :header-cell-class-name="headerCellClassName"
        :cell-style="cellStyle"
        :row-style="rowStyle"
        :header-cell-style="headerCellStyle"
        :stripe="stripe && !isTree"
        :row-config="{
          isHover: isRowHover,
          isCurrent: highlightCurrentRow,
          keyField: rowKey,
        }"
        :column-config="{ resizable: isColumnResizable,isCurrent:isColumnCurrent,isHover:isColumnHover }"
        :checkbox-config="{
          checkField: multiSelectKey,
          reserve: reserveSelection && isMultiSelect,
          checkStrictly:checkStrictly && isTree
        }"
        :seq-config="{ seqMethod: indexMethod }"
        :tooltip-config="{ theme: tooltipEffect }"
        :sort-config="{ remote: isPage }"
        :show-header="showHeader"
        :show-footer="showSummary"
        :footer-method="getSummaries"
        :footer-span-method="footerRowspanMethod"
        :span-method="spanMethod"
        :data="tableShowData"
        :showOverflow="showOverflow"
        @sort-change="sortChangeEvent"
        :menu-config="menuConfig"
        :tree-config="treeConfig"
        :scroll-y="myScrollY"
        :scroll-x="{enabled:!isExpand,gt:scrollXGt}"

        :mergeCells="mergeCells"
      >
        <!-- 拖动排序  -->
        <vxe-column align="center" :resizable="false" width="45" v-if="isSortable && !isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template>
            <div class="learun-table__drag-handler">
              <i class="el-icon-rank" />
            </div>
          </template>
        </vxe-column>

        <vxe-column
          v-if="isExpand"
          :fixed="isFixed ? 'left' : ''"
          type="expand"

          width="32"
          :resizable="false"
        >
          <template #content="scope">
            <slot v-bind="scope" name="table_expand"></slot>
          </template>

        </vxe-column>

        <vxe-column
          v-if="isMultiSelect"
          :fixed="isFixed ? 'left' : ''"
          align="center"
          type="checkbox"
          width="40"
          :resizable="false"
        ></vxe-column>
        <vxe-column
          v-if="isShowNum && !isTree"
          :fixed="isFixed ? 'left' : ''"
          align="center"
          type="seq"
          :title="ShowNumLabel"
          :width="seqWidth"
          showOverflow
          :resizable="false"
        ></vxe-column>

        <template v-for="(item, index) in tableColumns">
          <vxe-column
            v-if="!item.children"
            :key="`${item.prop || ''}${index}`"
            v-bind="item"
            :title="$t(item.label)"
            :field="item.prop"
            :show-overflow="item.isNotAutoWrap == false ? false : 'tooltip'"
            :show-header-overflow="
              item.isNotHeaderAutoWrap == false ? false : 'tooltip'
            "
            :fixed="isSortable && !isTree ? '' : item.fixed"
            :sortable="sortable || item.sortable"
            :min-width="item.minWidth"
            :tree-node="isTree && index == 0"
          >
            <template v-slot:header="{ column }">
              <span v-if="isRequired(column.property)" style="color: red"
                >*</span
              ><span>{{ column.title }}</span>
            </template>
            <template v-slot="slotProps">
              <slot v-bind="slotProps" :name="item.prop">{{
                columnText(slotProps.$index, slotProps.row, item, slotProps)
              }}</slot>
            </template>
          </vxe-column>
          <x-dynamic-column
            v-else
            :columnOption="item"
            :columnText="columnText"
            :isRequired="isRequired"
            :key="index"
            :title="$t(item.label)"
            :showOverflow="item.isNotAutoWrap == false ? false : 'tooltip'"
            :showHeaderOverflow="
              item.isNotHeaderAutoWrap == false ? false : 'tooltip'
            "
            :fixed="isSortable && !isTree ? '' : item.fixed"
            :sortable="sortable"
            :allProps="item.props"
            :colIndex="index"
          >
            <template
              v-for="myProp in item.props || []"
              v-slot:[myProp]="scope"
            >
              <slot v-bind="scope" :name="myProp"></slot>
            </template>
          </x-dynamic-column>
        </template>
        <slot></slot>
      </vxe-table>
    </div>
    <div v-if="isPage" class="l-x-table--pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes || [50, 100, 200, 500, 1000]"
        :page-size.sync="currentPageSize"
        :layout="isExpand?pageLayout.replace('sizes,',''):pageLayout"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <l-drawer
      :title="$t('表格列设置')"
      :visible.sync="columnsVisible"
      :showOk="true"
      :showClose="false"
      :wrapperClosable="true"
      :modal="false"
      size="320px"
      @ok="handleOk"
      okBtnLabel="保存"
      @opened="columnsSettingOpened"
    >
      <el-tree
        ref="columnsTree"
        node-key="_id"
        show-checkbox
        :data="treeColumns"
        @check="handleColumnsCheck"
      >
      </el-tree>
    </l-drawer>
  </div>
</template>
<script>
import tableUtil from "@util/tableUtil";
import xDynamicColumn from "./x-dynamic-column";

export default {
  name: "l-table",
  mixins: [tableUtil()],
  components: {
    xDynamicColumn,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    columnsType: {
      type: String,
      default: "tree",
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    minHeight: {
      type: [String, Number],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },

    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],

    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerCellStyle: [Function, Object],

    stripe: {
      type: Boolean,
      default: true,
    },

    tooltipEffect: String,

    showSummary: {
      type: Boolean,
      default: false,
    },
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,

    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "#",
    },

    isMultiSelect: Boolean,
    multiSelectKey: String,
    rowKey: String,

    reserveSelection: {
      type: Boolean,
      default: true,
    },

    isExpand: {
      type: Boolean,
      default: false,
    },
    // 树形
    isTree: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
    },
    pidKey: {
      type: String,
    },
    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    defaultExpandAll: Boolean,
    checkStrictly:Boolean,
    expandRowKeys: {
      type: Array,
    },

    sortable: {
      type: Boolean,
      default: false,
    },
    defaultSort: Object,
    isSortable: {
      type: Boolean,
      default: false,
    },
    spanMethod: Function,

    // 分页配置
    isPage: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },

    // 扩展属性
    isChild: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    lrTableName: {
      type: String,
      default: () => {
        return window.location.href;
      },
    },
    hasChildren: {
      type: String,
      default: "hasChildren",
    },

    scrollYGt:{
      type:Number,
      default:40,
    },
    scrollXGt:{
      type:Number,
      default:15,
    },

    borderType:{
      type:String,
    },
    isRowHover:{
      type:Boolean,
      default:true
    },
    showOverflow:{
      type:Boolean,
      default:true
    },
    isColumnCurrent:Boolean,
    isColumnHover:{
      type:Boolean,
      default:false
    },
    isColumnResizable:{
      type:Boolean,
      default:true
    },
    isNotMinWidth:Boolean,
    mergeCells:Array,
    isBigData:Boolean
  },
  data() {
    return {
      columnsVisible: false,
      columnsChecks: null,
      myPageSize: 0,
      sidx: "",
      isShowTable: true,
      isReloading: false,
      dataId:this.$uuid(),
      bigDataLength:-1,
    };
  },
  mounted() {
    this.setSort();
  },
  computed: {
    tableHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return "100%";
      }
    },
    tableWraperHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return this.height;
      }
    },
    isFixed() {
      return (
        this.arrayColumns.find((item) => {
          return item.fixed || item.fixed === "left" || item.fixed === "right";
        }) != undefined && !this.isSortable
      );
    },
    dataSourceLength(){
      if(this.bigDataLength != -1){
        return this.bigDataLength;
      }
      return this.dataSource.length;
    },
    seqWidth() {
      const max = this.indexMethod({ rowIndex: this.dataSourceLength }) + "";
      let  res = max.length * 10 + 20;
      if(res < 40){
        res = 40;
      }
      return res;
    },
    border() {
      if (
        this.tableColumns.findIndex(
          (t) => t.children && t.children.length > 0
        ) != -1
      ) {
        return "full";
      } else {
        return this.borderType || false;
      }
    },
    footerColNum() {
      let i = 0;
      if (this.isShowNum) {
        i++;
      }
      if (this.isMultiSelect) {
        i++;
      }
      return i;
    },

    myScrollY(){
      if(this.isExpand){
        return {enabled:false}
      }
      else if(this.lazy){
        return {enabled:true}
      }
      else{
        return {gt:this.scrollYGt,enabled:true}
      }
    },

    // 树形表格
    treeConfig() {
      if (this.isTree) {
        return {
          transform:this.lazy,
          rowField: this.idKey || this.rowKey,
          parentField: this.pidKey,
          expandAll: this.defaultExpandAll,
          indent: this.indent,
          lazy: this.lazy,
          /*loadMethod:async (params)=>{
            let res = await this.load(params);
            this.$nextTick(()=>{
              let {scrollTop,scrollLeft} = this.$refs.learunTable.getScroll();
              this.$refs.learunTable.scrollTo(scrollLeft, scrollTop -1);
            })
            return res;
          },*/
          loadMethod:this.load,
          hasChildField: this.hasChildren,
          hasChild: this.hasChildren,
          expandRowKeys: this.expandRowKeys,
          reserve:true
        };


      }
      return null;
    },

    // 右键菜单
    menuConfig() {
      return {
        enabled: true,
      };
    },

    // 列数据
    arrayColumns() {
      let columns; // 属性转化适应新的表格插件

      // 列的数据结构是树形结构，方便处理需要转成数组结构
      if (this.columnsType == "tree") {
        columns = this.$toArray(this.columns);
      } else {
        columns = this.columns;
      }

      for (let col of columns) {
        if (col.fixed == true) {
          col.fixed = "left";
        }
        if (col.fixed == false) {
          col.fixed = "";
        }

        if (col.width && col.minWidth) {
          delete col.width;
        }
      }

      return columns;
    },
    treeColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      return this.$toTree(this.$deepClone(this.arrayColumns));
    },
    chooseItem() {
      if (this.arrayColumns.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }

      let res;
      if (this.columnsChecks != null) {
        res = this.arrayColumns.filter(
          (t) => this.columnsChecks.indexOf(t._id) != -1
        );
      } else {
        res = this.arrayColumns.filter(
          (t) => this.defaultCheckedKeys.indexOf(t._id) != -1
        );
      }
      if (res.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }

      if (!this.isNotMinWidth && res.findIndex((t) => t.minWidth) == -1) {
        res[0].minWidth = res[0].width || "1";
        delete res[0].width;
      }
      return res;
    },
    tableColumns() {
      return this.$toTree(this.chooseItem);
    },
    defaultCheckedKeys() {
      const table_setting_cols = window.$getStore({
        name: "table_setting_cols",
      });
      if (table_setting_cols) {
        let choiceColumns;
        if (this.loginInfo) {
          // web
          if (
            table_setting_cols[this.loginInfo.f_UserId] &&
            table_setting_cols[this.loginInfo.f_UserId][this.lrTableName]
          ) {
            choiceColumns =
              table_setting_cols[this.loginInfo.f_UserId][this.lrTableName];
          }
        } else {
          choiceColumns = table_setting_cols[this.lrTableName]; // ui
        }
        if (choiceColumns) {
          return choiceColumns;
        }
      }

      return this.arrayColumns
        .filter((t) => t.isNotShow != true)
        .map((t) => t._id);
    },

    currentPageSize: {
      get() {
        if (this.myPageSize != 0) {
          return this.myPageSize;
        }
        return this.pageSize;
      },
      set(val) {
        this.myPageSize = val;
        this.$emit("update:pageSize", val);
      },
    },
    currentPage: {
      get() {
        if (!this.$validatenull(this.tablePage)) {
          return this.tablePage;
        } else {
          return 1;
        }
      },
      set(val) {
        this.$emit("update:tablePage", val);
      },
    },

    tableShowData() {
      let res = [];
      if (this.isTree && !this.lazy) {
        if(this.isReloading){
          return []
        }

        res = this.$toTree(
          this.dataSource,
          this.idKey || this.rowKey,
          this.pidKey,
          this.rowKey,
          this.rowKey
        );
      } else {
        res = this.dataSource;
      }
      return res;
    },
  },
  created(){
    window.tableData =  window.tableData || {}
  },
  beforeDestroy(){
    delete  window.tableData[this.dataId];
  },
  methods: {
    getDataSource(){
      let data = window.tableData[this.dataId];
      if(data){
        data;
      }
      else{
        return this.dataSource;
      }
    },
    setDataSource(data){
      this.bigDataLength = data.length;
      window.tableData[this.dataId] = data;
    },
    // 事件
    handleSelectionChange({
      checked,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("select", {
        checked,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleSelectAll({ checked, $event }) {
      this.$emit("selectAll", { checked, $event });
    },
    handleCellClick({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      triggerRadio,
      triggerCheckbox,
      triggerTreeNode,
      triggerExpandNode,
      $event,
    }) {
      this.$emit("rowClick", { row, column, $event });
      this.$emit("cellClick", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        triggerRadio,
        triggerCheckbox,
        triggerTreeNode,
        triggerExpandNode,
        $event,
      });
    },
    handleCellDblclick({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("rowDblclick", { row, column, $event });
      this.$emit("cellDblclick", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleCellMenu({ row, column, $event }) {
      this.$emit("rowContextmenu", { row, column, $event });
    },
    cellMouseEnter({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 当单元格 hover 进入时会触发该事件
      this.$emit("cellMouseEnter", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    cellMouseLeave({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 当单元格 hover 退出时会触发该事件
      this.$emit("cellMouseLeave", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    headerClick({
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      triggerResizable,
      triggerSort,
      triggerFilter,
      $event,
    }) {
      this.$emit("headerClick", {
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        triggerResizable,
        triggerSort,
        triggerFilter,
        $event,
      });
    },
    headerContextmenu({ type, column, columnIndex, $event }) {
      this.$emit("headerContextmenu", { type, column, columnIndex, $event });
    },
    filterChange({ column, property, values, datas, filterList, $event }) {
      this.$emit("filterChange", {
        column,
        property,
        values,
        datas,
        filterList,
        $event,
      });
    },
    currentChange({
      newValue,
      oldValue,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 当表格的当前行发生变化的时候会触发该事件，如果要高亮当前行，请打开表格的 highlight-current-row 属性
      this.$emit("currentChange", {
        newValue,
        oldValue,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    headerDagend({ $rowIndex, column, columnIndex, $columnIndex, $event }) {
      // 当拖动表头改变了列的宽度的时候会触发该事件
      this.$emit("headerDagend", {
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    expandChange({
      expanded,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("expandChange", {
        expanded,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.$emit("loadPageData", {
        rows: val,
        page: this.currentPage,
        sidx: this.pageSidx,
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("loadPageData", {
        rows: this.currentPageSize,
        page: val,
        sidx: this.pageSidx,
      });
    },
    sortChangeEvent({ sortList }) {
      if (this.isPage) {
        const pageSidx = sortList
          .map((item) => `${item.property} ${item.order}`)
          .join(", ");
        this.pageSidx = pageSidx;
        this.$emit("loadPageData", {
          rows: this.currentPageSize,
          page: this.currentPage,
          sidx: pageSidx,
        });
      }
    },


    // 方法
    reset() {
      this.clearSelection();
    },
    clearSelection() {
      this.$refs.learunTable.clearCheckboxRow();
      if(this.reserveSelection && this.isMultiSelect){
        this.$refs.learunTable.clearCheckboxReserve();
      }
    },
    toggleRowSelection(rows, selected){
      this.$refs.learunTable.setCheckboxRow(rows,selected);
    },
    getSelected(isFull){
      let res = this.$refs.learunTable.getCheckboxRecords();
      if(isFull){
        let reserveRecords = this.$refs.learunTable.getCheckboxReserveRecords();
        res.push(...reserveRecords);
      }


      if(this.isTree){
        res = this.$deepClone(res);
        for(let row of res){
          delete row.children;
        }
      }
      return res;
    },
    loadData(data){
      this.setDataSource(data);
      return this.$refs.learunTable.reloadData(data);
    },
    reLoadData(){
      this.isReloading = true;
      this.$nextTick(()=>{
        this.isReloading = false;
      });
    },
    doLayout() {
      this.isShowTable = false;
      this.$nextTick(() => {
        this.isShowTable = true;
      });
    },
    clearCurrentColumn(){
      return this.$refs.learunTable.clearCurrentColumn();
    },



    // 内部方法
    indexMethod({ rowIndex }) {
      if (this.isPage) {
        return (this.currentPage - 1) * this.currentPageSize + rowIndex + 1;
      } else {
        return rowIndex + 1;
      }
    },


    // 行排序(暂时不支持树形结构)
    setSort() {
      const callback = () => {
        const el = this.$refs.learunTable.$el.querySelectorAll(
          ".vxe-table--body-wrapper > table > tbody"
        )[0];

        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onEnd: (evt) => {
            const oldindex = evt.oldIndex;
            const newindex = evt.newIndex;
            let dataSource = this.getDataSource();
            const targetRow = dataSource.splice(oldindex, 1)[0];
            dataSource.splice(newindex, 0, targetRow);
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              dataSource
            );
          },
        });
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },

    // 表尾部 统计
    getSummaries(param) {
      if (this.summaryMethod) {
        return this.summaryMethod(param);
      }
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.sumText;
          return;
        }

        const myColumn = this.arrayColumns.find(
          (t) => t.prop == column.property
        );

        if (myColumn && myColumn.isSummary) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });
      return [sums];
    },
    footerRowspanMethod(params) {
      const { _rowIndex, _columnIndex } = params;
      if (_rowIndex === 0) {
        if (_columnIndex === 0) {
          return { rowspan: 1, colspan: this.footerColNum };
        } else if (_columnIndex < this.footerColNum) {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },

    // 校验
    isRequired(property) {
      let myColumn = this.arrayColumns.find((t) => t.prop == property);
      if (!myColumn) {
        return false;
      }
      return myColumn.required;
    },
    validate() {
      let res = true;
      let dataSource = this.getDataSource();
      if (this.required) {
        if (dataSource.length == 0) {
          this.$message({
            type: "error",
            message: this.$t(`请添加表格数据`),
          });
          return false;
        }
      }
      try {
        dataSource.forEach((row, index) => {
          this.arrayColumns.forEach((col) => {
            if (!col.isHidden) {
              if (col.required && this.$validatenull(row[col.prop])) {
                this.$message({
                  type: "error",
                  message: this.$t(`请输入第${index + 1}行-${col.label}`),
                });
                res = false;
                throw new Error();
              }

              if (col.patterns && col.patterns.length > 0) {
                col.patterns.forEach((pattern) => {
                  if (
                    pattern.reg &&
                    !this.$validatenull(row[col.prop]) &&
                    !new RegExp(
                      pattern.reg.substring(1, pattern.reg.length - 1)
                    ).test(row[col.prop])
                  ) {
                    this.$message({
                      type: "error",
                      message: this.$t(
                        `${pattern.msg}第${index + 1}行-${col.label}`
                      ),
                    });
                    res = false;
                    throw new Error();
                  }
                });
              }
            }
          });
        });
      } catch (error) {}
      return res;
    },

    // 动态显示列
    handleOk(showLoading, hideLoading) {
      showLoading("保存数据...");
      const table_setting_cols =
        window.$getStore({ name: "table_setting_cols" }) || {};
      if (this.loginInfo) {
        // web
        table_setting_cols[this.loginInfo.f_UserId] =
          table_setting_cols[this.loginInfo.f_UserId] || {};
        table_setting_cols[this.loginInfo.f_UserId][this.lrTableName] =
          this.chooseItem.filter((t) => t._id).map((t) => t._id);
      } else
        table_setting_cols[this.lrTableName] = this.chooseItem
          .filter((t) => t._id)
          .map((t) => t._id); // ui
      window.$setStore({
        name: "table_setting_cols",
        content: table_setting_cols,
      });
      setTimeout(() => {
        hideLoading();
        this.columnsVisible = false;
      }, 1000);
    },
    openColumnsSetting() {
      this.columnsVisible = true;
    },
    columnsSettingOpened() {
      let checks = this.columnsChecks || this.defaultCheckedKeys;
      checks = checks.filter(
        (t) =>
          this.arrayColumns.findIndex((t2) => t2._id == t && t2._hasChildren) ==
          -1
      );
      this.$refs.columnsTree.setCheckedKeys(checks);
    },
    handleColumnsCheck($node, data) {
      this.columnsChecks = data.checkedKeys.concat(data.halfCheckedKeys);
      this.doLayout();
    }

  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
